var __jsx = React.createElement;
import React from "react";
import clsx from "clsx";
import Loader from "@componentsShared/Loader/Loader";
import stl from "@/pages/checkout/bnpl/common/components/btn.module.css";
var ReusableBtn = function ReusableBtn(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "fill" : _ref$variant,
    className = _ref.className,
    bgColor = _ref.bgColor,
    textColor = _ref.textColor,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? "#154f9c" : _ref$borderColor,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  var baseStyles = "h-14 w-full cursor-pointer px-7 py-4 rounded-[5px] inline-flex justify-center items-center gap-2.5 text-base font-semibold relative";
  var variantStyles = {
    fill: "bg-[#154f9c] text-white",
    outline: "border border-[1px] bg-transparent text-[#154f9c] border-[#154f9c]",
    ghost: "bg-transparent text-[".concat(textColor ? textColor : "#154f9c", "]"),
    custom: ""
  };
  var customStyle = variant === "custom" ? clsx(bgColor ? "bg-[".concat(bgColor, "]") : "", textColor ? "text-[".concat(textColor, "]") : "", borderColor ? "border border-[".concat(borderColor, "]") : "") : "";
  var isDisabled = disabled || isLoading;
  var handleClick = function handleClick() {
    if (isDisabled) return;
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    className: clsx(baseStyles, variantStyles[variant], customStyle, className, isDisabled && "opacity-50 cursor-not-allowed"),
    style: variant === "custom" ? {
      backgroundColor: bgColor,
      color: textColor,
      border: borderColor ? "1px solid ".concat(borderColor) : undefined
    } : variant === "outline" ? {
      border: "1px solid  ".concat(borderColor)
    } : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-bold"
  }, label), isLoading && /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true,
    className: stl.btnLoading
  }));
};
export default ReusableBtn;